
export default {
  name: 'ChecklistBuilder',

  data() {
    return {
      checklists: [],
    };
  },

  methods: {
    addChecklist() {
      this.checklists.push({ name: '', items: [], newItem: '' });
    },

    removeChecklist(index) {
      this.checklists.splice(index, 1);
    },

    commitItem(checklistIndex) {
      const checklist = this.checklists[checklistIndex];
      const name = checklist.newItem?.trim();
      if (name) {
        checklist.items.push(name);
        checklist.newItem = '';
      }
    },

    focusItemInput(checklistIndex) {
      this.$nextTick(() => {
        const ref = this.$refs[`newItem_${checklistIndex}`];
        const el = Array.isArray(ref) ? ref[0] : ref;
        el?.focus();
      });
    },

    removeItem(checklistIndex, itemIndex) {
      this.checklists[checklistIndex].items.splice(itemIndex, 1);
    },

    /**
     * Return the draft checklists in a clean format, filtering empty ones.
     */
    getDraft() {
      return this.checklists
        .filter((c) => c.name.trim())
        .map((c) => ({
          name: c.name.trim(),
          items: c.items.filter((i) => i.trim()).map((i) => i.trim()),
        }));
    },

    reset() {
      this.checklists = [];
    },
  },
};
